export const BUSINESSES_DISABLED = 1
export const BUSINESSES_PENDING = 2
export const BUSINESSES_ACTIVATED = 3
export const BUSINESSES_REFUSED = 4
export const MODAL_INFO = 1
export const MODAL_INPUT = 2
export const TITLE_BUTTON_REJECT = 'Rechazar'
export const TITLE_BUTTON_DEACTIVATION = 'Desactivar'
export const IMAGE_DEFAULD =
  'https://stoconopmercurio.blob.core.windows.net/frontend/web-statics/iconos/catalogo.png'
export const BUSINESSES_LUEGOPAGO = 1
